import React, { cloneElement } from "react";
import NotFound from "../../pages/NotFound";
import usePermissions from "./usePermissions";

export default function PermissionsGate({
	children,
	errorProps = null,
	scopes = []
}) {
	const userCan = usePermissions();
	const permissionGranted = scopes.some((scope) => userCan(scope));

	if (!permissionGranted && !errorProps) return <></>;
	if (!permissionGranted && errorProps?.pageAuthorization === "unauthorized-page")
		return <NotFound />;
	if (!permissionGranted && errorProps)
		return cloneElement(children, { ...errorProps });

	return <>{children}</>;
}
